<template>
  <div id="oms-app" class="watermarked">
    <a-layout>
      <a-layout-sider
        v-model="collapsed"
        :trigger="null"
        collapsible
        v-show="!isCcrmActive && !isSupplierPortal && !isEmbeddedContent"
      >
        <section class="oms-menu" :class="{ collapsedStyle: collapsed, noCollapsedStyle: !collapsed }">
          <OmsMenu ref="mmsMenuRef" @onClick="onClick" />
        </section>
      </a-layout-sider>
    </a-layout>
    <a-layout id="layout-oms-main">
      <div
        class="oms-main"
        :class="{
          collapsedStyle1: collapsed && !isCcrmActive && !isSupplierPortal && !isEmbeddedContent,
          noCollapsedStyle1: !collapsed && !isCcrmActive && !isSupplierPortal && !isEmbeddedContent,
          fullWidth: isCcrmActive || isSupplierPortal || isEmbeddedContent,
        }"
      >
        <div
          class="oms-bar"
          v-show="!isCcrmActive && !isSupplierPortal && !hideHeader && !isEmbeddedContent"
        >
          <div class="oms-bar-tabs">
            <OmsTabs />
            <template v-if="tabList.length > 1">
              <img
                :src="pageTabDeleteIcon"
                class="tab-delete-btn"
                title="关闭所有页签"
                @click="delAllTabs"
              />
              <div class="tab-divider"></div>
            </template>
          </div>
          <div class="oms-bar-fn">
            <CmhubHeader v-if="cmhub" />
            <OmsHeader v-else @onClick="onClick" />
          </div>
        </div>
        <a-layout-content>
          <div
            id="oms-content"
            class="oms-content"
            :class="{
              'no-padding': isCcrmActive,
              'embedded-content': isEmbeddedContent,
            }"
          >
            <keep-alive>
              <router-view />
            </keep-alive>
          </div>
        </a-layout-content>
      </div>
    </a-layout>
    <ForceChangePassword v-model="changePWModal" />
  </div>
</template>

<script>
import OmsMenu from '../layout/OmsMenu.vue';
import OmsHeader from '../layout/OmsHeader.vue';
import OmsTabs from '../layout/OmsTabs.vue';
import Baseunified from '../utils/micro/baseunified';
import ForceChangePassword from '../layout/children/ForceChangePassword.vue';
import CmhubHeader from '@/features/cmhub/components/CmhubHeader.vue';
import { isCmhub } from '@/features/cmhub/config';

export default {
  name: 'OmsBase',
  components: {
    OmsMenu,
    OmsHeader,
    OmsTabs,
    ForceChangePassword,
    CmhubHeader,
  },
  data() {
    return {
      cmhub: isCmhub(),
      whiteList: 'MicroBase',
      collapsed: false,
      changePWModal: false,
      whetherAccountExists: localStorage.getItem('whetherAccountExists') || '0',
      isCcrmActive: false,
      isSupplierPortal: false,
      pageTabDeleteIcon: require('@/assets/images/pageTabDelete.png'),
    };
  },
  watch: {
    '$route.path': {
      handler(path) {
        this.isCcrmActive = path.startsWith('/ccrm/');
        // 仅供应商门户全宽展示（隐藏基座侧栏/页签），其它应用不变
        this.isSupplierPortal = localStorage.getItem('appId') === '20030'
          || path.startsWith('/scmInvestor/supplier-portal');
      },
      immediate: true,
    },
  },
  mounted() {
    if (localStorage.getItem('pwdStatus') === '0' && this.whetherAccountExists == '1') {
      this.changePWModal  = true;
    }else {
      this.changePWModal  = false;
    }
    this.Baseunified = new Baseunified();
    this.Baseunified.getWateMarkHost();
    this.Baseunified.starMicroApp();
  },
  methods: {
    onClick(collapsed) {
      this.collapsed = collapsed;
      this.$refs.mmsMenuRef.toggleCollapsed(collapsed);
    },
    delAllTabs() {
      // 只保留当前选中页签：传入当前路由 fullPath（state.tabs.curTab 从未被更新，恒为空串，
      // 会导致 delAllTab 匹配不到而清空全部并兜底回首页）。
      this.$store.commit('delAllTab', this.$route.fullPath);
    },
  },
  computed: {
    isEmbeddedContent() {
      return this.$route.query.isEmbeddedContent === 'true';
    },
    hideHeader() {
      const appId = localStorage.getItem('appId');
      return appId === '10016' && this.$route.path === '/customerSaas/customer/smartScreen';
    },
    tabList() {
      return this.$store.state.tabs.list;
    },
    routerKey() {
      const reg = /^\/(\w+?)\/.*/g;
      try {
        const { fullPath, name } = this.$route;
        if (name.indexOf('MicroBase') >= 0) {
          const res = reg.exec(fullPath);
          if (res && res.length && res[1]) {
            return res[1];
          }
          return '';
        }
        return '';
      } catch (e) {
        return '';
      }
    },
  },

};

</script>

<style lang="less" scoped>
@oms-menu-width: 232px;
@oms-menu-min-width: 80px;

.collapsedStyle {
  width: @oms-menu-min-width;
  //transition: width 0.1s ease-out 0s;
}

.noCollapsedStyle {
  width: @oms-menu-width;
  //transition: width 0.1s ease-out 0s;
}

.collapsedStyle1 {
  width: calc(100vw - @oms-menu-min-width);
  //transition: width 0.1s ease-out 0s;
}

.noCollapsedStyle1 {
  width: calc(100vw - @oms-menu-width);
  //transition: width 0.1s ease-out 0s;
}

.fullWidth {
  width: 100vw;
}

.no-padding {
  padding: 0 !important;
  height: 100vh !important;
  overflow: hidden !important;
}

.embedded-content {
  padding: 0 !important;
  height: 100vh !important;
}

#oms-app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-flow: row nowrap;

  .oms-menu {
    height: 100vh;
  }

  .oms-main {
    height: 100vh;
    display: flex;
    flex-flow: column nowrap;

    .oms-bar {
      width: 100%;
      height: 54px;
      flex-shrink: 0;
      box-sizing: border-box;
      padding: 0 18px 0 16px;
      gap: 14px;
      background: #fff;
      border-bottom: 1px solid #E8E8E8;
      display: flex;
      align-items: center;
    }

    .oms-bar-tabs {
      flex: 1;
      min-width: 0;
      height: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;

      .tab-delete-btn {
        width: 14px;
        height: 14px;
        flex-shrink: 0;
        cursor: pointer;
        margin-left: 4px;
        margin-right: 8px;
      }

      .tab-divider {
        flex-shrink: 0;
        width: 1px;
        height: 24px;
        background: #E5E6EB;
        margin: 0 8px;
      }
    }

    .oms-bar-fn {
      flex-shrink: 0;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .oms-content {
      box-sizing: border-box;
      padding: 16px;
      flex: 1;
      background: #eef3f9;
      overflow: auto;
      height: calc(100vh - 48px);
    }
  }
}
</style>
